// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-site-wide." + {"494":"021c4659b1d8973d","715":"533c7b526f9c4ad0"}[chunkId] + ".js";
};